import { styled } from '@mui/material/styles'
import { Box, Grid } from '@mui/material'
import { ulLiCss, olLiCss } from '../../../../../util'

export const Wrapper = styled(Box)(`
  width:1100px;
`)

export const WidgetWrapper = styled(Box)( props => `
  width: 100%;
  height: calc(100vh - 300px);
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 24px;
`)
  
export const ActionWrapper = styled(Box)(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  & button {
    margin: 0 !important;
  }
`)

export const LHS = styled(Grid)( props => `
  width: 100%;
  height:fit-content;
  display:flex;
  flex-direction: column;
`)

export const FormInnerWrapper = styled(Grid)( props => `
  overflow: auto;
  width:100%;
  max-height: calc(100vh - 560px);
`)

export const FormWrapper = styled(Grid)( props => `
  width: 100%;
  height:fit-content;
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
  margin: 0;
  padding: 0 0 18px;

  &.content {
    position: relative;

    & .addSegment {
      position: absolute;
      top: -30px;
      right:0;
    }
  }

`)

export const FormRow = styled(Box)(`
  width: 100%;
  gap:12px;
  display: flex;
  position:relative;

  & button {
    margin-top: 3px;
  }

  &.hideRow {
    display: none;
  }
`)

export const InputWrapper = styled(Box)(`
  width: 100%;
  padding-bottom: 8px;
`)

export const SelectWrapper = styled(Box)(`
  width: calc(50% - 4px);
  padding-bottom: 8px;
`)

export const SectionTitle = styled(Box)( props => `
    color: #000;
    font-size: 19px;
    font-weight: 400;
    width: 100%;
    padding-bottom: 8px;
    display: flex;
    justify-content: space-between;
`)

export const RHS = styled(Box)( props => `
  min-width: 620px;
`)

export const PreviewWrapper = styled(Box)( props => `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content : center;
  align-items: center;

  & .HiddenWrapper > div {
    border: 1px #d3d3d3 solid;
  }
`)

export const PreviewInnerWrapper = styled(Box)( props => `
  background: #F6F6F5;
  border-radius: 4px;
  display:block;
  // display:flex;
  // justify-content: center;
  // align-items: center;
  width:100%;
  height:calc(100% - 35px);
  overflow: auto;
  padding: 20px;

  & .editIcon {
    display:none;
  }
`)

export const D3PieWrapper = styled(Box)( props => `
  width: 100%;
  height: calc(100% - 25px);
  display:flex;

  & .my_tooltip {
    display: none;
  }
`)

export const CardPreview = styled(Box)( props => `
  display:flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 4px;
  background:#FFF;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);

  &:before {
    content: '${props.title}';
    width: 100%;
    height: 20px;
    display: block;
    font-size: 14px;
    font-weight: 400;
    color:#000;
    padding-bottom: 8px;
  }
`)

export const D3PieLegends = styled(Box)( props => `
  display:flex;
  flex-direction:column;
  width: 130px;
  height: 100%;
  align-items: start ;
  justify-content: center ;
`)

export const LegendLabel = styled(Box)( props => `
  width: 
  display:flex;
  padding: 0 0 5px 15px; 
  font-size: 12px;
  color:#000;
  position:relative;

  &:before {
    position: absolute;
    top: 5px;
    left: 3px;
    content:'';
    width:8px;
    height:8px;
    border-radius: 50%;
    display: block;
    background-color: ${props.color}
  }
`)

export const RtePreviewCss = `
  #tinymce { 
    ${ulLiCss};
    ${olLiCss};
    p {margin:0;}
  }
`
